import { api } from "../../index";

// Login do usuário
export const requestPasswordReset = async (email: string) => {
  const response = await api.post(
    "/request-password-reset",
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
